var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{ref:"confirmDialog",attrs:{"confirmText":_vm.$t('dialogs-confirm.buttons.remove'),"confirmColor":"red darken-1"}})}
var staticRenderFns = []

export { render, staticRenderFns }